module.exports = __webpack_public_path__ + "ff93e648291c70cc4e528ed98b43ae94.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/earrings-flower-s.png
// module id = 2798
// module chunks = 0